module.exports = __webpack_public_path__ + "static/media/detail-page-background.169575ee.png";